import { useRef } from 'react';

import { useGetResources } from '@hooks/useGetResources';
import { useLogin } from '@hooks/useLogin';

import Button from '@helsenorge/designsystem-react/components/Button';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import Lock from '@helsenorge/designsystem-react/components/Icons/Lock';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

export const LoginButton = (): React.JSX.Element | null => {
  const resources = useGetResources();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { login } = useLogin();

  return !isAuthorized() ? (
    <Button
      ref={buttonRef}
      onClick={(): void => {
        login(buttonRef);
      }}
    >
      <Icon svgIcon={Lock} />
      {resources?.loginButtonText}
    </Button>
  ) : null;
};
